module.exports = __webpack_public_path__ + "static/img/block4.dcc3d69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parkDescription/block4.png
// module id = X1TR
// module chunks = 1